import { DataTableDataSearchDto } from '@asset-metrix/portal-gateway-client-js';
import { useShallow } from 'zustand/react/shallow';

import { useNavigationQuery } from '../../api/portalGateway/navigation';
import { useStore } from '../../store';

export const useSelections = (
  instanceId: string
): NonNullable<DataTableDataSearchDto['selection']> =>
  useStore(
    useShallow((state) => state.filterSelections[instanceId] ?? emptySelections)
  );

const emptySelections: NonNullable<DataTableDataSearchDto['selection']> = {};

export const useGlobalSelections = () => {
  const { data } = useNavigationQuery();
  return useSelections(data?.rootPageId ?? '');
};
